import { IRuneInstance } from "../runesAPI/types"
import { IToolInstance } from "../toolsAPI/types"
import { IPreformInstance } from "../preformAPI/types"

export enum ITEM_TYPE {
  SHOVEL = "shovel",
  ELIXIR = "elixir",
  PREFORM = "preform",
  RUNES = "runes",
  RECIPE = "recipe",
  APPAREL = "apparel",
  RECIPE_AND_APPAREL = "recipe_and_apparel"
}

export type ShopItemData = IToolInstance | IPreformInstance | IRuneInstance
